import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrowsePageService_GetGenderedCardsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.grpc.lazy';
import {Log} from '@aboutyou/mlm';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useGetGenderedCards = () => {
  const targetGroup = useTargetGroupIdentifier();

  return useGrpcRequest(
    BrowsePageService_GetGenderedCardsLazy,
    {
      targetGroup,
    },
    {
      onSuccess: data => {
        if (
          data.type?.$case === 'cardSliders' &&
          data.type.cardSliders.cards.length === 0
        ) {
          Log.error(
            '@aboutyou/logic-components',
            'GetGenderedCards returned no cards',
          );
        }
      },
      keepPreviousData: true,
    },
  );
};

/**
 * this hook is used to pass down campaignCard to the legacy Welcome Page
 */
export const useGenderedCampaignCard = () => {
  const {data} = useGetGenderedCards();

  const cards =
    data?.type?.$case === 'cardSliders' ? data.type.cardSliders.cards : [];

  const campaignCard = cards.filter(
    card => card.type?.$case === 'campaignCard',
  )?.[0];

  return campaignCard;
};
